<template>
  <div class="title-container">
    <div class="title-content">
      <springText class="item-title" text="Character Production Consumption"></springText>
    </div>
    <fadeInAnimation>
      <div class="sub-title">
        In the mining system of MATR1X FIRE, characters are referred to as mining machines, and energy is considered
        electricity. When players equip a character NFT and complete ranked matches, energy is consumed, resulting in
        the
        production of $FIRE and Bounty Cases.
      </div>
      <div class="sub-title">
        Meanwhile, when health falls below 50, it begins to affect mining efficiency.
      </div>
      <div class="sub-title m-red">
        To maximize production, keep your character's energy and health value sufficient!
      </div>
    </fadeInAnimation>
  </div>
</template>

<script>
import responsiveMixin from "@/mixins/responsive";
import springText from "@/views/components/springText";
import fadeInAnimation from "@/views/components/fadeInAnimation";

export default {
  mixins: [responsiveMixin],
  components: { springText, fadeInAnimation },
  data() {
    return {};
  },
  mounted() { },
  methods: {},
  watch: {

  },
};
</script>

<style lang="scss" scoped>
@import "./index.scss";
</style>